import {
    ChangeDetectionStrategy,
    Component, contentChild,
    ContentChild,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    TemplateRef
} from "@angular/core";
import { Observable } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AsyncPipe, NgClass, NgFor, NgIf, NgTemplateOutlet } from "@angular/common";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { GetCustomerWishlistDataDocument, GetCustomerWishlistDataQuery } from "../../../common/gql/graphql";
import { DataService } from "../../../core/providers/data/data.service";
import { DropdownContentDirective } from "../../../shared/components/dropdown/dropdown-content.directive";
import { DropdownTriggerDirective } from "../../../shared/components/dropdown/dropdown-trigger.directive";
import { DropdownComponent } from "../../../shared/components/dropdown/dropdown.component";
import { notNullOrUndefined } from "../../../common/utils/not-null-or-undefined";

@Component({
    selector: 'kb-add-to-wishlist-button',
    templateUrl: './add-to-wishlist-button.component.html',
    styleUrls: ['./add-to-wishlist-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgTemplateOutlet,
        FontAwesomeModule,
        DropdownComponent,
        DropdownTriggerDirective,
        DropdownContentDirective,
        NgFor,
        NgClass,
        AsyncPipe,
    ],
})
export class AddToWishlistButtonComponent implements OnInit, OnChanges {
    @Input() showLabel = true;
    @Input() disabled = false;
    @Input() variantId: string;
    @Input() inWishlists: Array<{ id: string; name?: string }> | undefined;
    @Output() addClick = new EventEmitter<string | null>();
    customButtonTemplate = contentChild(TemplateRef);
    wishlists$: Observable<GetCustomerWishlistDataQuery['activeUserWishlists']>;
    label: string;
    added = new Set<string>();
    heartSolid = faHeart;
    heart = farHeart;
    constructor(private dataService: DataService) {}

    ngOnInit() {
        this.wishlists$ = this.dataService
            .query(GetCustomerWishlistDataDocument, {}, { fetchPolicy: 'cache-first' })
            .pipe(
                map(({ activeUserWishlists }) => activeUserWishlists),
                filter(notNullOrUndefined),
                startWith([]),
            );
    }

    ngOnChanges() {
        this.setLabel();
    }

    addToWishlist(wishlistId: string) {
        if (!this.disabled && this.variantId) {
            this.addClick.emit(wishlistId);
            this.added.add(this.variantId);
        }
    }

    private setLabel() {
        if (this.inWishlists?.length || this.added.size) {
            this.label = 'In wishlist';
        } else {
            this.label = 'Add to wishlist';
        }
    }
}
